// extracted by mini-css-extract-plugin
export default {"wrapper":"facilities_wrapper__iWl+4","title":"facilities_title__Z9yTm","facilities-wrapper":"facilities_facilities-wrapper__pIAOt"};